import * as ActionTypes from 'constants';

const subscriptions = (
  state = {
    subscriptions: [],
    creating_subscription: false,
    fetching_subscription: false,
    canceling_subscription: false,
    updating_subscription: false,
    wizard: {
      page: 1,
      items: [],
      map_regions: [],
      current_amount: 0
    }
  },
  action
) => {
  const { type, payload } = action;

  switch(type) {
    case ActionTypes.SET_SUBSCRIPTIONS: {
      return { ...state, subscriptions: payload };
    }
    case ActionTypes.TOGGLE_FETCHING_SUBSCRIPTION: {
      return { ...state, fetching_subscription: payload != null ? payload : !state.fetching_subscription };
    }
    case ActionTypes.TOGGLE_CREATING_SUBSCRIPTION: {
      return { ...state, creating_subscription: payload != null ? payload : !state.creating_subscription };
    }
    case ActionTypes.TOGGLE_CANCELING_SUBSCRIPTION: {
      return { ...state, canceling_subscription: payload != null ? payload : !state.canceling_subscription };
    }
    case ActionTypes.TOGGLE_UPDATING_SUBSCRIPTION: {
      return { ...state, updating_subscription: payload != null ? payload : !state.updating_subscription };
    }
    case ActionTypes.CREATE_SUBSCRIPTION_SUCCESS: {
      return { ...state, subscription: payload, creating_subscription: false };
    }
    case ActionTypes.FETCH_SUBSCRIPTION_SUCCESS: {
      return { ...state, subscriptions: payload, fetching_subscription: false };
    }
    case ActionTypes.UPDATE_SUBSCRIPTION_SUCCESS: {
      return {
        ...state,
        subscriptions: state.subscriptions.map(s => s._id == payload._id ? payload : s),
        updating_subscription: false
      };
    }
    case ActionTypes.CANCEL_SUBSCRIPTION_SUCCESS: {
      return { ...state, subscription: null, canceling_subscription: false };
    }
    case ActionTypes.REACTIVATE_SUBSCRIPTION_SUCCESS: {
      return {
        ...state,
        subscriptions: state.subscriptions.map(s => ({ ...s, status: 'active' })),
        updating_subscription: false
      };
    }
    case ActionTypes.UPDATE_SUBSCRIPTION_WIZARD: {
      return { ...state, wizard: { ...state.wizard, ...payload } };
    }
  }

  return state;
}

export default subscriptions;



// WEBPACK FOOTER //
// ./src/common/reducers/subscriptions.js